import React from 'react'
import Layout from '../../components/Layout'
import Intro from './Intro';
import WasWirMachen from './WasWirMachen';
import WhyChooseUs from './WhyChooseUs';

const About = () => {
  return (
    <Layout>
      <div>
        <Intro />
        <WasWirMachen />
        <WhyChooseUs />
      </div>
    </Layout>
  )
}

export default About;